import { z } from "zod";
import { COMMENT_VISIBILITY, DOCUMENT_OWNER_TYPES, ENTITY_TYPES } from "../enums.ts";

export const CommentInput = z.object({
  entityType: z.enum(ENTITY_TYPES),
  entityId: z.string().uuid(),
  parentCommentId: z.string().uuid().nullable().optional(),
  body: z.string().min(1).max(10_000),
  visibility: z.enum(COMMENT_VISIBILITY).default("internal"),
  mentions: z.array(z.string().uuid()).default([]),
});
export type CommentInput = z.infer<typeof CommentInput>;

export const CommentUpdateInput = z.object({ body: z.string().min(1).max(10_000) });
export const CommentVisibilityInput = z.object({ visibility: z.enum(COMMENT_VISIBILITY) });
export const CommentQuery = z.object({ entityType: z.enum(ENTITY_TYPES), entityId: z.string().uuid() });

export const DOCUMENT_KINDS = ["certificate", "label_front", "label_back", "spec", "report", "photo", "protocol", "other"] as const;

export const DocumentMeta = z.object({
  ownerType: z.enum(DOCUMENT_OWNER_TYPES),
  ownerId: z.string().uuid(),
  docType: z.string().max(60).default("other"),
  description: z.string().max(400).nullable().optional(),
  kind: z.enum(DOCUMENT_KINDS).default("other"),
});
export type DocumentMeta = z.infer<typeof DocumentMeta>;

export const DocumentQuery = z.object({
  ownerType: z.enum(DOCUMENT_OWNER_TYPES),
  ownerId: z.string().uuid(),
});

/** One normalised inbound email, as the intake webhook receives it from any provider. */
export const InboundEmailInput = z.object({
  messageId: z.string().min(1).max(500),
  inReplyTo: z.string().max(500).nullable().optional(),
  from: z.object({ email: z.string().email(), name: z.string().max(200).nullable().optional() }),
  to: z.string().max(200),
  subject: z.string().max(1000).default("(no subject)"),
  text: z.string().max(200_000).default(""),
  html: z.string().max(500_000).nullable().optional(),
  attachments: z.array(z.object({ filename: z.string().min(1).max(300), contentType: z.string().min(1).max(120), contentBase64: z.string().max(14_000_000) })).max(10).default([]),
});
export type InboundEmailInput = z.infer<typeof InboundEmailInput>;
